<template>
  <button class="arrow">
    <span></span>
    <span></span>
  </button>
</template>

<script>
export default {
  name: 'ArrowButton',
  props: {
    direction: String
  }
}
</script>

<style scoped lang="scss">
.button,
button,
input[type='button'],
input[type='reset'],
input[type='submit'] {
  display: inline-block;
  padding: 3.0rem;
  border: none;
  border-radius: 50%;
  color: #fff;
  background-color: $color-orange;
  transition: background-color 100ms, transform 100ms;
  outline: 0;
  cursor: pointer;

  &:hover {
    background-color: lighten($color-orange, 5%);
  }

  &:active {
    transform: translateY(.2rem);
  }

  span {
    position: absolute;
    display: block;
    width: 1.5rem;
    height: .2rem;
    background-color: $color-white;
    transform-origin: 0 50%;

    &:first-child {
      transform: translateY(.6rem) rotate(-45deg) translateX(-.1rem);
    }

    &:last-child {
      transform: translateY(.6rem) rotate(-135deg) translateX(-.1rem);
    }
  }
}
</style>
